import {
  SUPERSET_VERTICAL_TABLE,
  SUPERSET_VERTICAL_TABLE_SUCCESS,
  SUPERSET_VERTICAL_TABLE_ERROR,
  SUPERSET_VERTICAL_TABLE_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetVerticalTable = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_VERTICAL_TABLE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_VERTICAL_TABLE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_VERTICAL_TABLE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_VERTICAL_TABLE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetVerticalTable;
